import React, { useContext } from 'react';
import TableWithState from '../../components/TableWithState/TableWithState';
import { ETables } from '../../types/enums/ETables';
import useColumnsHeaders from '../../utils/useColumnsHeaders';
import useCellStatusStyleHandler from '../../utils/useCellStatusStyleHandler';
import RowCheckbox from '../Packages/components/RowCheckbox/RowCheckbox';
import { Cell, Column } from 'react-table';
import HeaderCheckbox from '../Packages/components/HeaderCheckbox/HeaderCheckbox';
import { NSPartnerCodes } from '../../types/interfaces/NSPartnerCodes';
import { SessionContext } from '../../contexts/session/SessionContext';

const tableName = ETables.PartnerCodes;

const PartnerCodes = () => {
  const { permissions } = useContext(SessionContext);

  const cellStyleHandler = useCellStatusStyleHandler();

  const dataFormatter = (dataTable: NSPartnerCodes.ITableItem[]): any =>
    dataTable.map((code) => ({
      status: code.status.current,
      commercialCode: code.commercialCode,
      technicalCode: code.technicalCode,
      customersCountWhoInstalledApp: code.customersCountWhoInstalledApp,
      partnerCampaign: code.partnerCampaign,
      rewardType: code.rewardType,
      rewardThreshold: code.rewardThreshold.amount + ' ' + code.rewardThreshold.dataUnit,
      insertedCount: code.insertedCount,
      usedCount: code.usedCount,
      _id: code._id,
      jsxCheckbox: (cell: Cell) => <RowCheckbox tableName={tableName} cell={cell} propNameForId={'technicalCode'} />,
    }));

  const columns = useColumnsHeaders([
    {
      accessorAsHeader: 'jsxCheckbox',
      customHeader: (column: { data: { code: string }[] } & Column) => (
        <HeaderCheckbox tableName={tableName} idList={column.data.map((code) => code.code)} />
      ),
    },
    { accessorAsHeader: 'status' },
    { accessorAsHeader: 'commercialCode' },
    { accessorAsHeader: 'partnerCampaign' },
    { accessorAsHeader: 'rewardType' },
    { accessorAsHeader: 'rewardThreshold' },
    { accessorAsHeader: 'customersCountWhoInstalledApp' },
    { accessorAsHeader: 'technicalCode' },
    { accessorAsHeader: 'insertedCount' },
    { accessorAsHeader: 'usedCount' },
  ]);

  return (
    <TableWithState
      tableName={tableName}
      dataFormatter={dataFormatter}
      columns={columns}
      cellStyleHandler={cellStyleHandler}
      // addable={permissions.partnercodes.edit}
      exportable={true}
    />
  );
};

export default PartnerCodes;
